module.exports = __webpack_public_path__ + "img/box3_icon3.4890db56.png";